import React, { useEffect, useState } from 'react';
import { syncQueue, subscribeSync } from '@/lib/syncQueue';
import { CloudArrowUp, WifiSlash, CheckCircle } from '@phosphor-icons/react';

export default function SyncBanner() {
  const [pending, setPending] = useState(syncQueue.count());
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const unsub = subscribeSync(() => {
      setPending(syncQueue.count());
      setOnline(navigator.onLine);
    });
    return unsub;
  }, []);

  const bg = !online ? '#A44A3F' : pending > 0 ? '#D97706' : '#2D6A4F';
  const Icon = !online ? WifiSlash : pending > 0 ? CloudArrowUp : CheckCircle;
  const text = !online
    ? `Offline — ${pending} record${pending === 1 ? '' : 's'} queued`
    : pending > 0
      ? `${pending} record${pending === 1 ? '' : 's'} pending sync`
      : 'All records synced';

  return (
    <div
      data-testid="sync-banner"
      className="border-b-2 border-carbon text-white px-4 py-2 flex items-center gap-2"
      style={{ background: bg }}
    >
      <Icon size={20} weight="bold" />
      <span className="font-display font-bold uppercase tracking-widest text-xs">
        {text}
      </span>
    </div>
  );
}
